import axios from 'axios';
import mixin from './mixin.js';
import constants from '../constants.js';
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import { Stuck } from 'stuck-js';

const agendaDetailApp = {
    mixins: [mixin],
    data() {
        return {
            dataApi: '',
            loading: false,
            events: [],
            director: '',
            selectedEventId: '',
            culture: 'nl-NL',
            dataFavourites: {
                title: '',
                add: '',
                remove: ''
            },
            dataFreeLabel: 'gratis',
            wishlist: [],
            titleMinSize: 16,
            currentTitleSize: 110,
            subtitleMinSize: 12,
            currentSubtitleSize: 24,
            resizeHandler: null,
            hasReadmore: false,
            readmoreActive: false,
            constants: constants
        }
    },
    computed: {
        selectedEvent() {
            if (!this.events.length) return null;
            if (this.events[0].isExhibit && this.events[0].exhibitShows.length) return this.events[0].exhibitShows[0];
            if (!this.selectedEventId) return this.events[0];
            return this.events.find(event => event.id === this.selectedEventId);
        },
        restEvents() {
            if (!this.events.length) return null;
            if (this.selectedEventId === '') return this.events;
            return this.events.filter(event => event.id !== this.selectedEventId).length ? this.events.filter(event => event.id !== this.selectedEventId).length : null;
        },
        wishlistIds() {
            let result = this.wishlist.map(event => event.id);
            return result;
        }
    },
    methods: {
        async init() {
            this.loading = true;
            if (this.$el.parentNode.dataset.api) this.dataApi = this.$el.parentNode.dataset.api;
            if (this.$el.parentNode.dataset.selectedeventid) this.selectedEventId = this.$el.parentNode.dataset.selectedeventid;
            if (this.$el.parentNode.dataset.currentculture) this.culture = this.$el.parentNode.dataset.currentculture;
            if (this.$el.parentNode.dataset.director) this.director = this.$el.parentNode.dataset.director;
            if (this.$el.parentNode.dataset.freelabel) this.dataFreeLabel = this.$el.parentNode.dataset.freelabel;
            const response = await this.fetchData();
            if (response && response.status === 200) {
                this.events = response.data;
                this.events = this.events.map(event => {
                    return {
                        ...event,
                        favourite: this.wishlistIds.some(wishlistId => wishlistId === event.id),
                    }
                });
                if (this.events.length) {
                    if (this.events[0].isExhibit) {
                        this.events[0].exhibitShows.forEach(show => {
                            this.generateJsonLd(show);
                        });
                    } else {
                        this.events.forEach(event => {
                            this.generateJsonLd(event);
                        });
                    }
                }
            }
            this.loading = false;
            this.$nextTick(() => {
                bulmaCollapsible.attach('.is-collapsible-vue');
                new Stuck([
                    {
                        selector: '.orderbar',
                        wrapper: 'body'
                    },
                ]);

                this.adjustFontSize(this.$refs.title, this.titleMinSize);
                this.adjustFontSize(this.$refs.subtitle, this.subtitleMinSize, true);

                let cachedWidth = window.innerWidth;
                this.resizeHandler = this.debounce(() => {
                    const newWidth = window.innerWidth;
                    if (newWidth !== cachedWidth) {
                        this.adjustFontSize(this.$refs.title, this.titleMinSize);
                        this.adjustFontSize(this.$refs.subtitle, this.subtitleMinSize, true);
                        if (this.$refs.collapsibleText && this.$refs.collapseTrigger) {
                            this.checkClamped(this.$refs.collapsibleText);
                        }
                    }
                }, 300);

                if (this.$refs.title || this.$refs.subtitle || (this.$refs.collapsibleText && this.$refs.collapseTrigger)) {
                    window.addEventListener('resize', this.resizeHandler);
                }

                if (this.$refs.collapsibleText && this.$refs.collapseTrigger) {
                    this.checkClamped(this.$refs.collapsibleText);
                }
            });
        },
        async fetchData() {
            try {
                const response = await axios.post(this.dataApi);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        getVenue(event) {
            if (!event.targets && !event.venueRoom) return null;
            const venue = {};
            if (event.targets) {
                if (event.targets.length === 1) {
                    venue.targetName = event.targets[0].name;
                } else {
                    if (event.targets.filter(target => target.isMainTarget).length) {
                        event.targets.filter(target => target.isMainTarget)
                    } else {
                        venue.targetName = event.targets.filter(target => target.id !== this.constants.targets.all)[0].name;
                    }
                }
            }
            if (event.venueRoom) {
                venue.roomName = event.venueRoom.name;
            }
            return venue
        },
        getRegularPrice(priceArray) {
            if (!priceArray || !priceArray.length) return null;
            let price = priceArray.filter(priceItem => priceItem.id === this.constants.priceTypes.regular);
            if (price.length) return price;
            return priceArray[0];
        },
        getPriceText(price) {
            if (!price || !price.amount) return this.dataFreeLabel;
            if (price.amount.amount === 0) return this.dataFreeLabel;
            return this.toCurrency(price.amount.amount, this.culture, price.amount.currencyCode);
        },
        adjustFontSize(obj, minSize, isSub = false) {
            if (!obj) return;

            const vw = window.innerWidth;
            const computedStyle = window.getComputedStyle(obj);
            const maxLines = parseInt(computedStyle['-webkit-line-clamp']);
            if (!maxLines || isNaN(maxLines)) {
                obj.removeAttribute('style');
                return;
            }

            const lineHeightRaw = computedStyle.lineHeight;
            const fontFamily = computedStyle.fontFamily;
            const fontWeight = computedStyle.fontWeight;
            const wordBreak = computedStyle.wordBreak;
            const width = computedStyle.width;

            let targetSize = isSub ? this.fluidType(18, 24)(vw) : this.fluidType(54, 110)(vw);
            let fontSize = targetSize;

            const clone = document.createElement('div');
            clone.textContent = obj.textContent;
            clone.style.position = 'absolute';
            clone.style.top = '-9999px';
            clone.style.left = '-9999px';
            clone.style.visibility = 'hidden';
            clone.style.width = width;
            clone.style.lineHeight = lineHeightRaw;
            clone.style.fontFamily = fontFamily;
            clone.style.fontWeight = fontWeight;
            clone.style.wordBreak = wordBreak;
            clone.style.display = 'block';
            clone.style.whiteSpace = 'normal';

            document.body.appendChild(clone);

            const range = document.createRange();

            const isClamped = () => {
                range.selectNodeContents(clone);
                const rects = range.getClientRects();
                return rects.length > maxLines;
            };

            
            clone.style.setProperty('font-size', `${fontSize}px`, 'important');

            while (isClamped() && fontSize > minSize) {
                fontSize -= 1;
                clone.style.setProperty('font-size', `${fontSize}px`, 'important');
            }

            document.body.removeChild(clone);

            if (!isSub) {
                this.currentTitleSize = fontSize;
            } else {
                this.currentSubtitleSize = fontSize;
            }
        },
        fluidType(minValue, maxValue, minVw = 769, maxVw = 1504) {
            const factor = (1 / (maxVw - minVw)) * (maxValue - minValue);
            function calculateFontSize(vw) {
                const fluidValue = minValue - (minVw * factor) + (vw * factor);
                return Math.min(Math.max(minValue, fluidValue), maxValue);
            }
            return calculateFontSize;
        },
        checkClamped(elm) {
            elm.classList.remove('is-active');
            this.hasReadmore = elm.scrollHeight > elm.clientHeight;
        },
        generateJsonLd(event) {
            const gradedReviews = event.reviews.filter(review => review.grade !== null);
            const lowestGrade = Math.min(...gradedReviews.map(review => review.grade));
            const highestGrade = Math.max(...gradedReviews.map(review => review.grade));
            const totalGrade = gradedReviews.reduce((sum, review) => sum + review.grade, 0);
            const averageGrade = totalGrade / gradedReviews.length;
            let reviews = [];
            event.reviews.forEach(review => {
                reviews.push({
                    "@type": "Review",
                    "author": review.authorName ? review.authorName : review.title,
                    "datePublished": review.postedAt !== '0001-01-01T00:00:00' ? review.postedAt : "",
                    "reviewBody": review.body ? review.body.replace('\"','') : "",
                    "name": review.title,
                    "reviewRating": {
                        "@type": "Rating",
                        "bestRating": highestGrade,
                        "ratingValue": review.grade ? review.grade : "",
                        "worstRating": lowestGrade
                    }
                });
            });
            let ld = document.createElement('script');
            ld.type = 'application/ld+json';
            ld.text = JSON.stringify({
                "@context": "https://www.schema.org",
                "@type": "Event",
                "@id": "https://" + window.location.hostname + "/#event-" + event.id,
                "name": event.title,
                "location": {
                    "@id": "https://" + window.location.hostname + "/#location"
                },
                "organizer": {
                    "@id": "https://" + window.location.hostname + "/#organization"
                },
                "startDate": event.start,
                "endDate": event.end,
                "performer": {
                    "@type": "PerformingGroup",
                    "name": event.performer
                },
                "director": this.director,
                "image": "https://" + window.location.hostname + event.imageSets[0].originalUrl,
                "description": event.teaser,
                "review": reviews,
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": averageGrade,
                    "reviewCount": gradedReviews.length
                },
                url: "https://" + location.host + location.pathname + "?showId=" + event.id,
                "offers": {
                    "@type": "Offer",
                    "priceSpecification": {
                        "@type": "PriceSpecification",
                        "price": this.getRegularPrice(event.prices) ? this.getRegularPrice(event.prices).amount.amount : 0,
                        "priceCurrency": this.getRegularPrice(event.prices) ? this.getRegularPrice(event.prices).amount.currencyCode : "EUR",
                    },
                    "availability": event.status ? event.status.isClickable ? "http://schema.org/InStock" : "http://schema.org/OutOfStock" : "http://schema.org/InStock",
                    "url": event.status ? event.status.orderUrl : "https://" + location.host + location.pathname + "?showId=" + event.id,
                }
            });
            document.querySelector('body').appendChild(ld);
        }
    },
    onBeforeUnmount() {
        window.removeEventListener('resize', this.resizeHandler);
    },
    mounted() {
        this.wishlist = localStorage.hasOwnProperty('wishlist') ? JSON.parse(localStorage.wishlist) : [];
        let self = this;
        window.addEventListener('wishlist-localstorage-changed', (event) => {
            self.wishlist = JSON.parse(event.detail.storage);
            self.events = self.events.map(event => {
                return {
                    ...event,
                    favourite: self.wishlistIds.some(wishlistId => wishlistId === event.id),
                }
            });
        });
        this.init();
    }
}

export default agendaDetailApp;